import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { SITE } from "@/data/site";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/projects", label: "Projects" },
  { to: "/about", label: "About" },
  { to: "/gallery", label: "Gallery" },
  { to: "/blog", label: "Blog" },
  { to: "/emi-calculator", label: "EMI" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-[0_8px_32px_rgba(11,93,59,0.08)]" : "bg-white/80 backdrop-blur-sm"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 md:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
          <img src="/logo.png" alt="Next Gen Properties" className="h-11 w-11 object-contain" />
          <span className="leading-tight">
            <span className="block font-heading font-bold text-[#0B5D3B] text-[15px]">NEXT GEN PROPERTIES</span>
            <span className="block text-[10px] tracking-[0.3em] text-[#D4AF37] font-semibold">TELANGANA</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-3.5 py-2 rounded-md text-sm font-medium transition-colors ${
                loc.pathname === l.to ? "text-[#0B5D3B]" : "text-gray-700 hover:text-[#0B5D3B]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${SITE.phoneRaw}`} data-testid="nav-call" className="flex items-center gap-1.5 text-sm font-semibold text-[#0B5D3B]">
            <Phone size={16} /> {SITE.phone}
          </a>
          <button
            data-testid="nav-book-visit"
            onClick={() => nav("/book-visit")}
            className="rounded-full bg-[#0B5D3B] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#094e32] transition-colors"
          >
            Book Free Site Visit
          </button>
        </div>

        <button data-testid="mobile-menu-toggle" className="lg:hidden text-[#0B5D3B]" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-gray-100 px-5 py-4 space-y-1">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="block py-2.5 text-gray-800 font-medium">{l.label}</Link>
          ))}
          <button onClick={() => nav("/book-visit")} className="w-full mt-2 rounded-full bg-[#0B5D3B] text-white py-3 font-semibold">
            Book Free Site Visit
          </button>
        </div>
      )}
    </header>
  );
};
